import { Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "./Layout";
import { Login } from "./Login";
import { useAuth } from "./auth";
import { ChatPage } from "../chat/ChatPage";
import { ListsPage } from "../lists/ListsPage";
import { ReviewPage } from "../review/ReviewPage";
import { SettingsPage } from "../settings/SettingsPage";
import { SharePage } from "../share/SharePage";

export function App() {
  const { authenticated, loading } = useAuth();

  if (loading) {
    return <div className="splash">Ładowanie…</div>;
  }

  if (!authenticated) {
    return <Login />;
  }

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<ChatPage />} />
        <Route path="/chat" element={<ChatPage />} />
        <Route path="/listy/*" element={<ListsPage />} />
        <Route path="/przeglad" element={<ReviewPage />} />
        <Route path="/ustawienia" element={<SettingsPage />} />
        {/* Faza 7: cel share targetu z manifestu (Android "Udostępnij"). */}
        <Route path="/share" element={<SharePage />} />
        <Route path="*" element={<Navigate to="/chat" replace />} />
      </Route>
    </Routes>
  );
}
